import { useTranslation } from "react-i18next";
import { CiiData } from "../../types/CiiData";
import React, { ReactElement } from "react";
import "./Cii.css";

type Props = {
    ciiData: CiiData;
};

export const Cii = (props: Props): ReactElement => {
    const { t } = useTranslation("common");

    const ciiData = props.ciiData;

    const bannerColour = ciiData.projectedBand.backgroundColor;
    const lastRecordedCii =
        t("inspectionReport.decarbonisation.cii.last_recorded_title") +
        " (" +
        ciiData.vesselData.lastCIIYear +
        ")";
    const lastAttainedCiiBand =
        t("inspectionReport.decarbonisation.cii.last_attained_title") +
        " (" +
        ciiData.vesselData.lastCIIYear +
        ")";
    const numberColour = ciiData.band.colour;

    return (
        <div>
            <div className="grid pt-4 align-content-end">
                <div className="col-6">
                    <div className="col p-1 cii_header">
                        {" "}
                        {lastRecordedCii}{" "}
                    </div>
                    <div
                        className="col p-1 cii_number"
                        style={{ color: numberColour }}
                    >
                        {" "}
                        {ciiData.currentCII}{" "}
                    </div>
                    <div className="col p-1 co2"> gCO2/t.nm</div>
                </div>
                <div className="col-6">
                    <div className={"col p-1 cii_header"}>
                        {" "}
                        {lastAttainedCiiBand}{" "}
                    </div>
                    <div
                        className={"col p-1 cii_number"}
                        style={{ color: numberColour }}
                    >
                        {" "}
                        {ciiData.currentCIIBand}{" "}
                    </div>
                    <div className={"col p-1 co2"}> gCO2/t.nm</div>
                </div>
            </div>
            <div className="pt-3">
                <div
                    className={"result_box"}
                    style={{ backgroundColor: bannerColour }}
                >
                    <div className={"result_box_text"}>
                        {ciiData.cciBannerSentence}
                    </div>
                </div>
            </div>
        </div>
    );
};
